import { createOutlineIcon } from "../createIcon";

export const FileOutlineIcon = createOutlineIcon(
  <>
    <path d="M13.125 5V8.375C13.125 8.84099 13.5168 9.21875 14 9.21875H17.5M13.2751 5H8.75C7.7835 5 7 5.75552 7 6.6875V16.8125C7 17.7445 7.7835 18.5 8.75 18.5H15.75C16.7165 18.5 17.5 17.7445 17.5 16.8125V9.07399C17.5 8.62643 17.3156 8.19721 16.9874 7.88074L14.5126 5.49426C14.1844 5.17779 13.7393 5 13.2751 5Z" />
  </>,
  "FileOutlineIcon"
);
